export interface HighlightedLabelPart {
  isMatch: boolean;
  key: string;
  text: string;
}

export const getNextOptionIndex = ({
  activeOptionIndex,
  direction,
  optionCount,
}: {
  activeOptionIndex: number;
  direction: 1 | -1;
  optionCount: number;
}) => {
  if (activeOptionIndex === -1) {
    if (direction === 1) {
      return 0;
    }

    return optionCount - 1;
  }

  return Math.min(Math.max(activeOptionIndex + direction, 0), optionCount - 1);
};

export function getHighlightedLabelParts(
  label: string,
  query: string,
): HighlightedLabelPart[] {
  const normalizedQuery = query.trim().toLowerCase();

  if (normalizedQuery.length === 0) {
    return [{ isMatch: false, key: `0-${label.length}`, text: label }];
  }

  const normalizedLabel = label.toLowerCase();
  const parts: HighlightedLabelPart[] = [];
  let cursor = 0;
  let matchStart = normalizedLabel.indexOf(normalizedQuery, cursor);

  while (matchStart !== -1) {
    if (matchStart > cursor) {
      parts.push({
        isMatch: false,
        key: `${cursor}-${matchStart}`,
        text: label.slice(cursor, matchStart),
      });
    }

    const matchEnd = matchStart + normalizedQuery.length;
    parts.push({
      isMatch: true,
      key: `${matchStart}-${matchEnd}`,
      text: label.slice(matchStart, matchEnd),
    });
    cursor = matchEnd;
    matchStart = normalizedLabel.indexOf(normalizedQuery, cursor);
  }

  if (cursor < label.length) {
    parts.push({
      isMatch: false,
      key: `${cursor}-${label.length}`,
      text: label.slice(cursor),
    });
  }

  return parts;
}
